var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/MemberProfile/MemberProfileInfoInner.jinja"] = require( "front/components/MemberProfile/MemberProfileInfoInner.jinja" );
dependencies["front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja"] = require( "front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfileInfo.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileInfo.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/MemberProfile/MemberProfileInfoInner.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileInfo.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "MemberProfileInfoInner")) {
var t_7 = t_4.MemberProfileInfoInner;
} else {
cb(new Error("cannot import 'MemberProfileInfoInner'")); return;
}
context.setVariable("MemberProfileInfoInner", t_7);
output += "\n";
env.getTemplate("front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileInfo.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "MemberProfileButtonsEdit")) {
var t_11 = t_8.MemberProfileButtonsEdit;
} else {
cb(new Error("cannot import 'MemberProfileButtonsEdit'")); return;
}
context.setVariable("MemberProfileButtonsEdit", t_11);
output += "\n\n";
var macro_t_12 = runtime.makeMacro(
[], 
["data", "isOwner"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("isOwner", Object.prototype.hasOwnProperty.call(kwargs, "isOwner") ? kwargs["isOwner"] : false);var t_13 = "";t_13 += "\n    <div class=\"MemberProfileInfo\">\n        <div class=\"MemberProfileInfo-wrapper\">\n            ";
t_13 += runtime.suppressValue((lineno = 8, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileInfoInner"), "MemberProfileInfoInner", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"isOwner": runtime.contextOrFrameLookup(context, frame, "isOwner")})])), env.opts.autoescape);
t_13 += "\n        </div>\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isOwner")) {
t_13 += "\n            <div class=\"MemberProfileInfo-buttonsEdit\">\n                ";
t_13 += runtime.suppressValue((lineno = 12, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MemberProfileButtonsEdit"), "MemberProfileButtonsEdit", context, [runtime.makeKeywordArgs({"hidden": false,"block": "info","memberId": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")})])), env.opts.autoescape);
t_13 += "\n            </div>\n        ";
;
}
t_13 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_13);
});
context.addExport("MemberProfileInfo");
context.setVariable("MemberProfileInfo", macro_t_12);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfileInfo.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileInfo.jinja
// module id = 104
// module chunks = 0